import request from '@/utils/request'


// 查询供应商列表
export function listSupplier(query) {
  return request({
    url: '/biz/admin/supplier/supplier/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询供应商分页
export function pageSupplier(query) {
  return request({
    url: '/biz/admin/supplier/supplier/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询供应商详细
export function getSupplier(data) {
  return request({
    url: '/biz/admin/supplier/supplier/detail',
    method: 'get',
    params: data
  })
}

// 新增供应商
export function addSupplier(data) {
  return request({
    url: '/biz/admin/supplier/supplier/add',
    method: 'post',
    data: data
  })
}

// 修改供应商
export function updateSupplier(data) {
  return request({
    url: '/biz/admin/supplier/supplier/edit',
    method: 'post',
    data: data
  })
}

// 删除供应商
export function delSupplier(data) {
  return request({
    url: '/biz/admin/supplier/supplier/delete',
    method: 'post',
    data: data
  })
}

export function commonSupplier(data) {
  return request({
    url: '/biz/admin/supplier/supplier/common',
    method: 'post',
    data: data
  })
}
